const SiteDescription = () => {
	const block = document.querySelectorAll(".site-description");
	if (!block) {
		return;
	}

	block.forEach((el) => {
		const toggle = el.querySelectorAll(".site-description__toggle");

		toggle.forEach((item) => {
      item.addEventListener("click", (e) => {
        const text = e.target.closest(".site-description__list-footer").parentElement.querySelector(".site-description__list-text");

        e.target.classList.toggle("active");
        text.classList.toggle("active");
      });
    });
	});
};

export default SiteDescription;
